import { createBrowserRouter } from "react-router-dom";
import HomePage from '../pages/HomePage'
import Layout from "../pages/Layout"
import ProductPage from "../pages/ProductPage"
import ProductDetailPage from '../pages/ProductDetailPage'

const router = createBrowserRouter([
    {
        element: <Layout/>,
        children: [
            {
                path: "/",
                element: <HomePage/>
            },
            {
                path: "/products",
                element: <ProductPage/>
            },
            {
                path: "/products/:productSlug",
                element: <ProductDetailPage/>
            }
        ]
    }
]);

export default router;
